import { elements, modifiers } from '#components/generics/js/styles.js'
import * as utilities from '#utilities/js/styles.js'
import * as eaMail from '#components/mail/js/styles.js'
import { events } from '#utilities/js/lightboxes/lightbox.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import pointerEnter
  from '@mailobj-browser/front/js/events/types/pointerEnter.js'
import pointerLeave
  from '@mailobj-browser/front/js/events/types/pointerLeave.js'
import focus from '@mailobj-browser/front/js/events/types/focus.js'
import blur from '@mailobj-browser/front/js/events/types/blur.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import removed from '@mailobj-browser/front/js/tree/removed.js'
import object from '@mailobj-browser/front/js/utils/object.js'

const buttons = new WeakMap()
const openers = new WeakMap()
const items = new WeakMap()

const onClose = object(listener, {
  type: events.close,
  passive,
  task: (
    { ownerDocument }
  ) => {
    requestAnimationFrame(() => {
      const nestedItems = items.get(ownerDocument)

      for (const button of nestedItems) {
        button.classList.remove(eaMail.modifiers.menu_button.hover)
      }
    })
  }
})

const onPointerEnterOpener = object(listener, {
  type: pointerEnter,
  passive,
  task: opener => {
    requestAnimationFrame(() => {
      const button = openers.get(opener)

      button.classList.add(eaMail.modifiers.menu_button.hover)
    })
  }
})

const onFocusOpener = object(listener, {
  type: focus,
  passive,
  task: opener => {
    requestAnimationFrame(() => {
      const button = openers.get(opener)

      button.classList.add(eaMail.modifiers.menu_button.hover)
    })
  }
})

const onPointerLeaveOpener = object(listener, {
  type: pointerLeave,
  passive,
  task: (
    opener,
    { relatedTarget }
  ) => {
    requestAnimationFrame(() => {
      const button = openers.get(opener)

      if (button === relatedTarget || opener.classList.contains(utilities.modifiers.lightbox.open)) {
        return
      }

      button.classList.remove(eaMail.modifiers.menu_button.hover)
    })
  }
})

const onBlurOpener = object(listener, {
  type: blur,
  passive,
  task: (
    opener,
    { relatedTarget }
  ) => {
    requestAnimationFrame(() => {
      const button = openers.get(opener)

      if (button === relatedTarget || opener.classList.contains(utilities.modifiers.lightbox.open)) {
        return
      }

      button.classList.remove(eaMail.modifiers.menu_button.hover)
    })
  }
})

const onPointerEnterButton = object(listener, {
  type: pointerEnter,
  passive,
  task: button => {
    requestAnimationFrame(() => {
      button.classList.add(eaMail.modifiers.menu_button.hover)
    })
  }
})

const onFocusButton = object(listener, {
  type: focus,
  passive,
  task: button => {
    requestAnimationFrame(() => {
      button.classList.add(eaMail.modifiers.menu_button.hover)
    })
  }
})

const onPointerLeaveButton = object(listener, {
  type: pointerLeave,
  passive,
  task: (
    button,
    { relatedTarget }
  ) => {
    requestAnimationFrame(() => {
      const dropdownActions = buttons.get(button)

      if (dropdownActions === relatedTarget) {
        return
      }

      button.classList.remove(eaMail.modifiers.menu_button.hover)
    })
  }
})

const onBlurButton = object(listener, {
  type: blur,
  passive,
  task: (
    button,
    { relatedTarget }
  ) => {
    requestAnimationFrame(() => {
      const dropdownActions = buttons.get(button)

      if (dropdownActions === relatedTarget) {
        return
      }

      button.classList.remove(eaMail.modifiers.menu_button.hover)
    })
  }
})

export default item => {
  const opener = one(`:scope > .${utilities.modifiers.lightbox.dropdown}`, item)
  const button = one(`:scope > [class*='${modifiers.nav_button.action}-']`, item)
  if (opener && button) {
    const { ownerDocument } = opener

    const buttonBadge = one(`:scope > [class*='${modifiers.nav_button.action}-'] .${elements.button_badge}`, item)

    if (buttonBadge) {
      onPointerEnterButton.listen(button)
      onPointerLeaveButton.listen(button)
      onFocusButton.listen(button)
      onBlurButton.listen(button)
      onPointerEnterOpener.listen(opener)
      onPointerLeaveOpener.listen(opener)
      onFocusOpener.listen(opener)
      onBlurOpener.listen(opener)
      onClose.listen(opener)
      buttons.set(button, opener)
      openers.set(opener, button)

      if (!items.has(ownerDocument)) {
        items.set(ownerDocument, new Set())
      }

      items.get(ownerDocument).add(button)

      queueMicrotask(async () => {
        await removed(button)
        buttons.delete(button)
        openers.delete(opener)
        items.get(ownerDocument).delete(button)
      })
    }
  }
}
